import { api } from "source/registrations/api/client"

export const getAnswers = ({ registerableId, attendeeId, ...options }) => {
  const path = `/registrations/v2/registrations/${registerableId}/attendees/${attendeeId}/answers`
  return api.get(path, options)
}

export const postAnswer = ({ registerableId, attendeeId, ...attributes }) => {
  const path = `/registrations/v2/registrations/${registerableId}/attendees/${attendeeId}/answers`
  return api.post(path, { data: { attributes } })
}

export const patchAnswer = ({
  registerableId,
  attendeeId,
  id: answerId,
  ...attributes
}) => {
  const path = `/registrations/v2/registrations/${registerableId}/attendees/${attendeeId}/answers/${answerId}`
  return api.patch(path, { data: { attributes } })
}

export const destroyAnswer = ({ registerableId, attendeeId, id: answerId }) => {
  const path = `/registrations/v2/registrations/${registerableId}/attendees/${attendeeId}/answers/${answerId}`
  return api.destroy(path)
}
